import { EventDataEvents } from "../Consts";
import { EulerStateManager } from "../EulerStateManager";
import { EventData } from "../EventData";
import { BaseState } from "../States/BaseState";

class EventPlaying extends BaseState<EulerStateManager> {
  public id = "EventPlaying"; // A unique identifier for the state
  constructor(stateManager: EulerStateManager) {
    super(stateManager); // Pass the StateManager to the base class
    this.bindEvents();
    this.subscribeToEvents();
  }

  public onEnter(stateManager: EulerStateManager): void {
    this.stateManager = stateManager; // Set the StateManager reference
    super.onEnter(stateManager); // Call the super method
    this.stateManager.onEnterEventPlayingState();
  }

  private bindEvents() {
    this.transition = this.transition.bind(this);
  }

  private subscribeToEvents() {
    const eventData = EventData.getInstance();
    eventData.subscribeToEvent(
      EventDataEvents.ON_COMPLETED_MESSAGE_RECEIVED,
      this.transition,
    );
  }

  public transition(): void {
    this.stateManager?.changeState(this.stateManager.eulerEventEndState);
  }

  public onExit(): void {
    super.onExit();
  }
}

export { EventPlaying };
